import { firstValueFrom } from "rxjs";
import { api } from "../../common/api/index.ts";
import { LoginStatus } from "../../common/types.ts";
import { loginStatus$ } from "../store/loginV2.ts";
import { v2Options } from "../store/v2Options.ts";

const getV2OptionsRequest = api.path("/api/v2/options").method("get").create();

export async function getV2Options(): Promise<void> {
	const loginStatus = await firstValueFrom(loginStatus$);
	const headers: Record<string, string> = {};
	if (loginStatus.status === LoginStatus.LOGGED_IN) {
		headers.authorization = `Bearer ${loginStatus.token}`;
	}
	const { data } = await getV2OptionsRequest({}, { headers });
	v2Options.set(data);
}
